import "core-js/modules/es.array.map.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21;

import { observable, runInAction, computed, makeObservable, action } from "mobx";
import * as yup from "yup";
import { ORDER_TYPES } from "@dp/common";
import { persist } from "mobx-persist";
import BrandRules from "../../utils/BrandRules";
var PLEASE_SPECIFY_A_NUMBER = "Please specify a number";

var _SCHEMA = yup.object({
  includeSilverware: yup["boolean"]().when(["isComplementaryItemsEnabled", "orderTypeValue"], {
    is: function is(isComplementaryItemsEnabled, orderTypeValue) {
      return orderTypeValue === 0 && isComplementaryItemsEnabled;
    },
    then: yup["boolean"]().typeError("Please select an option").required("Please select an option"),
    otherwise: yup["boolean"]().nullable()
  }),
  quantity: yup.number().when("isQuantityVisible", {
    is: true,
    then: yup.number().typeError(PLEASE_SPECIFY_A_NUMBER).required(PLEASE_SPECIFY_A_NUMBER)
  }),
  noOfGuest: yup.number().when("isNoOfGuestsEnabled", {
    is: true,
    then: yup.number().typeError(PLEASE_SPECIFY_A_NUMBER).required(PLEASE_SPECIFY_A_NUMBER)
  })
});

var OrderInstructionModel = (_dec = persist("list"), (_class = /*#__PURE__*/function () {
  function OrderInstructionModel(platformUtil) {
    var _this = this;

    _classCallCheck(this, OrderInstructionModel);

    _initializerDefineProperty(this, "_includeSilverware", _descriptor, this);

    _initializerDefineProperty(this, "_specialInstructions", _descriptor2, this);

    _initializerDefineProperty(this, "_showSpecialInstructions", _descriptor3, this);

    _initializerDefineProperty(this, "_sessionAttributes", _descriptor4, this);

    _initializerDefineProperty(this, "_sessionDetails", _descriptor5, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor6, this);

    _initializerDefineProperty(this, "_plates", _descriptor7, this);

    _initializerDefineProperty(this, "_heatingkit", _descriptor8, this);

    _initializerDefineProperty(this, "_bowls", _descriptor9, this);

    _initializerDefineProperty(this, "_cups", _descriptor10, this);

    _initializerDefineProperty(this, "_ice", _descriptor11, this);

    _initializerDefineProperty(this, "_componentRef", _descriptor12, this);

    _initializerDefineProperty(this, "_occasionInfo", _descriptor13, this);

    _initializerDefineProperty(this, "_occasionSelected", _descriptor14, this);

    _initializerDefineProperty(this, "_noOfGuest", _descriptor15, this);

    _initializerDefineProperty(this, "_quantity", _descriptor16, this);

    _initializerDefineProperty(this, "_isBreadIncluded", _descriptor17, this);

    _initializerDefineProperty(this, "_condimentsList", _descriptor18, this);

    _initializerDefineProperty(this, "_errorsYPosition", _descriptor19, this);

    _initializerDefineProperty(this, "_showError", _descriptor20, this);

    _initializerDefineProperty(this, "_isBagFeeSelected", _descriptor21, this);

    _defineProperty(this, "platformUtil", void 0);

    _defineProperty(this, "setErrorsYPosition", function (code, yPos) {
      runInAction(function () {
        _this._errorsYPosition[code] = yPos;
      });
    });

    this.platformUtil = platformUtil;
    runInAction(function () {
      _this._showSpecialInstructions = false;
      _this._specialInstructions = "";
      _this._plates = false;
      _this._heatingkit = false;
      _this._bowls = false;
      _this._cups = false;
      _this._ice = false;
      _this._quantity = 1;
    });
    makeObservable(this);
  }

  _createClass(OrderInstructionModel, [{
    key: "setShowError",
    value: function setShowError(val) {
      this._showError = val;
    }
  }, {
    key: "selectCondiment",

    /*
     * When condiment selection is made, this will set the corresponding boolean flag
     */
    value: function selectCondiment(selectedCondiment, isChecked) {
      var _this2 = this;

      runInAction(function () {
        _this2._condimentsList = _this2.condimentsList.map(function (condiment) {
          if (condiment.condimentName === selectedCondiment.condimentName) {
            condiment.isSelected = isChecked;
          }

          return condiment;
        });
      });
    }
  }, {
    key: "setSessionAttributes",
    value: function setSessionAttributes(_sessionAttributes) {
      var _this3 = this;

      runInAction(function () {
        var _sessionAttributes$ca;

        _this3._sessionAttributes = _sessionAttributes;
        _this3._isBagFeeSelected = _sessionAttributes === null || _sessionAttributes === void 0 ? void 0 : (_sessionAttributes$ca = _sessionAttributes.carryoutBagDetails) === null || _sessionAttributes$ca === void 0 ? void 0 : _sessionAttributes$ca.cartHasBag;
      });
    }
  }, {
    key: "setSessionDetails",
    value: function setSessionDetails(_sessionDetails) {
      var _this4 = this;

      runInAction(function () {
        _this4._sessionDetails = _sessionDetails;
      });
    }
  }, {
    key: "setAppAttributes",
    value: function setAppAttributes(_appAttributes) {
      var _this5 = this;

      runInAction(function () {
        var _this5$_appAttributes, _this5$_appAttributes2, _this5$_appAttributes3, _this5$_appAttributes4, _this5$_appAttributes5, _this5$_appAttributes6;

        _this5._appAttributes = _appAttributes;
        var appCondiments = (_appAttributes === null || _appAttributes === void 0 ? void 0 : _appAttributes.condiments) || [];
        _this5.condimentsList = appCondiments.map(function (co) {
          return {
            condimentName: co,
            isSelected: false
          };
        });
        var defaultBreadIncluded = (_this5$_appAttributes = _this5._appAttributes) === null || _this5$_appAttributes === void 0 ? void 0 : (_this5$_appAttributes2 = _this5$_appAttributes.configs) === null || _this5$_appAttributes2 === void 0 ? void 0 : _this5$_appAttributes2.isBreadIncluded;
        var defaultSilverwareValue = (_this5$_appAttributes3 = _this5._appAttributes) === null || _this5$_appAttributes3 === void 0 ? void 0 : (_this5$_appAttributes4 = _this5$_appAttributes3.configs) === null || _this5$_appAttributes4 === void 0 ? void 0 : _this5$_appAttributes4.defaultSilverwareValue;

        if (_this5._includeSilverware === null || _this5._includeSilverware === undefined) {
          _this5._includeSilverware = defaultSilverwareValue === "true" ? true : defaultSilverwareValue === "false" ? false : null;
        }

        if (_this5._isBreadIncluded === null || _this5._isBreadIncluded === undefined) {
          _this5._isBreadIncluded = defaultBreadIncluded === "false" ? false : true;
        }

        if ((_this5._quantity === null || _this5._quantity === undefined) && (_this5$_appAttributes5 = _this5._appAttributes) !== null && _this5$_appAttributes5 !== void 0 && (_this5$_appAttributes6 = _this5$_appAttributes5.configs) !== null && _this5$_appAttributes6 !== void 0 && _this5$_appAttributes6.defaultQtyDisplay) {
          var _this5$_appAttributes7, _this5$_appAttributes8;

          _this5._quantity = parseInt((_this5$_appAttributes7 = _this5._appAttributes) === null || _this5$_appAttributes7 === void 0 ? void 0 : (_this5$_appAttributes8 = _this5$_appAttributes7.configs) === null || _this5$_appAttributes8 === void 0 ? void 0 : _this5$_appAttributes8.defaultQtyDisplay);
        }
      });
    }
  }, {
    key: "handleInvalidModel",
    value: function handleInvalidModel() {
      var isMobile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.platformUtil.scrollToElement(this.componentRef, isMobile ? 30 : 0);
      this.platformUtil.dispatchEvent("AnalyticsEvent", "DisplayModal", {
        modalIntent: "Error modal for missing order instruction items",
        modalContent: "Error modal for missing order instruction items",
        modalName: "OrderInfo-Error-Modal"
      });
    }
  }, {
    key: "isValid",
    get: function get() {
      return _SCHEMA.isValidSync(this);
    }
  }, {
    key: "errors",
    get: function get() {
      var errObj = {};

      try {
        _SCHEMA.validateSync(this, {
          abortEarly: false
        });
      } catch (e) {
        var error = e;
        error.inner.forEach(function (err) {
          errObj[err.params.path] = err.message;
        });
      }

      return errObj;
    }
  }, {
    key: "errorsYPosition",
    get: function get() {
      return this._errorsYPosition;
    }
  }, {
    key: "showError",
    get: function get() {
      return this._showError;
    }
  }, {
    key: "includeSilverware",
    get: function get() {
      return this._includeSilverware;
    },
    set: function set(_includeSilverware) {
      var _this6 = this;

      runInAction(function () {
        _this6._includeSilverware = _includeSilverware;
      });
    }
  }, {
    key: "isBreadIncluded",
    get: function get() {
      return this._isBreadIncluded;
    },
    set: function set(_isBreadIncluded) {
      var _this7 = this;

      runInAction(function () {
        _this7._isBreadIncluded = _isBreadIncluded;
      });
    }
  }, {
    key: "condimentsList",
    get: function get() {
      return this._condimentsList;
    },
    set: function set(_condimentsList) {
      var _this8 = this;

      runInAction(function () {
        _this8._condimentsList = _condimentsList;
      });
    }
    /*
     * Return the user selected condiments to submit order API
     */

  }, {
    key: "selectedCondiments",
    get: function get() {
      return this.condimentsList.filter(function (condiment) {
        return condiment.isSelected;
      }).map(function (con) {
        return con.condimentName;
      }).join(",");
    }
  }, {
    key: "specialInstructions",
    get: function get() {
      if (this._showSpecialInstructions) {
        return this._specialInstructions;
      } else {
        return "";
      }
    },
    set: function set(_specialInstructions) {
      var _this9 = this;

      runInAction(function () {
        _this9._specialInstructions = _specialInstructions;
      });
    }
  }, {
    key: "showSpecialInstructions",
    get: function get() {
      return this._showSpecialInstructions;
    },
    set: function set(_showSpecialInstructions) {
      var _this10 = this;

      runInAction(function () {
        _this10._showSpecialInstructions = _showSpecialInstructions;
      });
    }
  }, {
    key: "plates",
    get: function get() {
      return this._plates;
    },
    set: function set(_plates) {
      var _this11 = this;

      runInAction(function () {
        _this11._plates = _plates;
      });
    }
  }, {
    key: "heatingkit",
    get: function get() {
      return this._heatingkit;
    },
    set: function set(_heatingkit) {
      var _this12 = this;

      runInAction(function () {
        _this12._heatingkit = _heatingkit;
      });
    }
  }, {
    key: "bowls",
    get: function get() {
      return this._bowls;
    },
    set: function set(_bowls) {
      var _this13 = this;

      runInAction(function () {
        _this13._bowls = _bowls;
      });
    }
  }, {
    key: "cups",
    get: function get() {
      return this._cups;
    },
    set: function set(_cups) {
      var _this14 = this;

      runInAction(function () {
        _this14._cups = _cups;
      });
    }
  }, {
    key: "ice",
    get: function get() {
      return this._ice;
    },
    set: function set(_ice) {
      var _this15 = this;

      runInAction(function () {
        _this15._ice = _ice;
      });
    }
  }, {
    key: "componentRef",
    get: function get() {
      return this._componentRef;
    },
    set: function set(_componentRef) {
      var _this16 = this;

      runInAction(function () {
        _this16._componentRef = _componentRef;
      });
    }
  }, {
    key: "isComplementaryItemsEnabled",
    get: function get() {
      var _this$_sessionAttribu;

      return (_this$_sessionAttribu = this._sessionAttributes) === null || _this$_sessionAttribu === void 0 ? void 0 : _this$_sessionAttribu.complimentaryItemEnabled;
    }
  }, {
    key: "isSilverwareRequired",
    get: function get() {
      var _this$_appAttributes, _this$_appAttributes$;

      return ((_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : (_this$_appAttributes$ = _this$_appAttributes.configs) === null || _this$_appAttributes$ === void 0 ? void 0 : _this$_appAttributes$.defaultSilverwareValue) === "";
    }
  }, {
    key: "orderTypeValue",
    get: function get() {
      var _this$_sessionDetails, _this$_sessionDetails2, _this$_sessionDetails3;

      return (_this$_sessionDetails = this._sessionDetails) === null || _this$_sessionDetails === void 0 ? void 0 : (_this$_sessionDetails2 = _this$_sessionDetails.successResponse) === null || _this$_sessionDetails2 === void 0 ? void 0 : (_this$_sessionDetails3 = _this$_sessionDetails2.sessionContext) === null || _this$_sessionDetails3 === void 0 ? void 0 : _this$_sessionDetails3.orderTypeValue;
    }
  }, {
    key: "isComplementaryItemEnabledForToGoPickup",
    get: function get() {
      var _this$_sessionAttribu2;

      return ((_this$_sessionAttribu2 = this._sessionAttributes) === null || _this$_sessionAttribu2 === void 0 ? void 0 : _this$_sessionAttribu2.complimentaryItemEnabled) && this.orderTypeValue === 0;
    }
  }, {
    key: "isToGoOrder",
    get: function get() {
      return this.orderTypeValue === 0;
    }
  }, {
    key: "showAllItems",
    get: function get() {
      var _this$_sessionAttribu3;

      return ((_this$_sessionAttribu3 = this._sessionAttributes) === null || _this$_sessionAttribu3 === void 0 ? void 0 : _this$_sessionAttribu3.complimentaryItemEnabled) && this.orderTypeValue !== 0;
    }
  }, {
    key: "showHeatingKit",
    get: function get() {
      var _this$_sessionAttribu4;

      return ((_this$_sessionAttribu4 = this._sessionAttributes) === null || _this$_sessionAttribu4 === void 0 ? void 0 : _this$_sessionAttribu4.foodItemPresent) && this.orderTypeValue === ORDER_TYPES.CATERING_DELIVERY;
    }
  }, {
    key: "isFoodItem",
    get: function get() {
      var _this$_sessionAttribu5;

      return (_this$_sessionAttribu5 = this._sessionAttributes) === null || _this$_sessionAttribu5 === void 0 ? void 0 : _this$_sessionAttribu5.foodItemPresent;
    }
  }, {
    key: "isSoupItem",
    get: function get() {
      var _this$_sessionAttribu6;

      return (_this$_sessionAttribu6 = this._sessionAttributes) === null || _this$_sessionAttribu6 === void 0 ? void 0 : _this$_sessionAttribu6.soupItemPresent;
    }
  }, {
    key: "isBeverageItem",
    get: function get() {
      var _this$_sessionAttribu7;

      return (_this$_sessionAttribu7 = this._sessionAttributes) === null || _this$_sessionAttribu7 === void 0 ? void 0 : _this$_sessionAttribu7.beverageItemPresent;
    }
    /*
     * Check if utensilsList contains Bread ('BC') or not
     * This bread section is shown only for LH brand
     */

  }, {
    key: "isBreadSelectionEnabled",
    get: function get() {
      var _this$_sessionAttribu8, _this$_sessionAttribu9;

      return ((_this$_sessionAttribu8 = this._sessionAttributes) === null || _this$_sessionAttribu8 === void 0 ? void 0 : (_this$_sessionAttribu9 = _this$_sessionAttribu8.utensilsList) === null || _this$_sessionAttribu9 === void 0 ? void 0 : _this$_sessionAttribu9.indexOf("BC")) > -1;
    }
  }, {
    key: "isQuantityEnabled",
    get: function get() {
      var _this$_appAttributes2, _this$_appAttributes3;

      return ((_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : (_this$_appAttributes3 = _this$_appAttributes2.configs) === null || _this$_appAttributes3 === void 0 ? void 0 : _this$_appAttributes3.complimentary_Items_Quantity_Enabled) === "true";
    }
  }, {
    key: "isQuantityVisible",
    get: function get() {
      return this.isQuantityEnabled && this._includeSilverware;
    }
  }, {
    key: "isNoOfGuestsEnabled",
    get: function get() {
      var _this$_sessionAttribu10;

      return (this === null || this === void 0 ? void 0 : (_this$_sessionAttribu10 = this._sessionAttributes) === null || _this$_sessionAttribu10 === void 0 ? void 0 : _this$_sessionAttribu10.noOfGuestEnabled) && ((this === null || this === void 0 ? void 0 : this.orderTypeValue) === ORDER_TYPES.TOGO_PICKUP || (this === null || this === void 0 ? void 0 : this.orderTypeValue) === ORDER_TYPES.CATERING_PICKUP);
    }
  }, {
    key: "special_instruction_maxlength",
    get: function get() {
      var _this$_appAttributes4, _this$_appAttributes5, _this$_appAttributes6, _this$_appAttributes7, _this$_appAttributes8, _this$_appAttributes9;

      var maxLength;

      switch (this.orderTypeValue) {
        case ORDER_TYPES.CATERING_DELIVERY:
          maxLength = parseInt(this === null || this === void 0 ? void 0 : (_this$_appAttributes4 = this._appAttributes) === null || _this$_appAttributes4 === void 0 ? void 0 : (_this$_appAttributes5 = _this$_appAttributes4.configs) === null || _this$_appAttributes5 === void 0 ? void 0 : _this$_appAttributes5.delivery_checkout_special_instruction_maxlength) || 256;
          break;

        case ORDER_TYPES.CATERING_PICKUP:
          maxLength = parseInt(this === null || this === void 0 ? void 0 : (_this$_appAttributes6 = this._appAttributes) === null || _this$_appAttributes6 === void 0 ? void 0 : (_this$_appAttributes7 = _this$_appAttributes6.configs) === null || _this$_appAttributes7 === void 0 ? void 0 : _this$_appAttributes7.catering_checkout_special_instruction_maxlength) || 256;
          break;

        default:
          maxLength = parseInt(this === null || this === void 0 ? void 0 : (_this$_appAttributes8 = this._appAttributes) === null || _this$_appAttributes8 === void 0 ? void 0 : (_this$_appAttributes9 = _this$_appAttributes8.configs) === null || _this$_appAttributes9 === void 0 ? void 0 : _this$_appAttributes9.togo_checkout_special_instruction_maxlength) || 50;
      }

      return maxLength;
    }
  }, {
    key: "displaySpecialInstructions",
    get: function get() {
      var _this$_appAttributes10;

      return this === null || this === void 0 ? void 0 : (_this$_appAttributes10 = this._appAttributes) === null || _this$_appAttributes10 === void 0 ? void 0 : _this$_appAttributes10.orderDescEnabled;
    } //@gsdsmm2 Need to revisit

  }, {
    key: "isSilverWareShown",
    get: function get() {
      return this.isComplementaryItemEnabledForToGoPickup && this.includeSilverware || this.showAllItems && this.includeSilverware;
    }
  }, {
    key: "cateringOrderPartysize",
    get: function get() {
      if (this._sessionDetails && this._sessionAttributes) {
        var _this$_sessionAttribu11, _this$_sessionAttribu12;

        var partySize = (_this$_sessionAttribu11 = this._sessionAttributes) === null || _this$_sessionAttribu11 === void 0 ? void 0 : (_this$_sessionAttribu12 = _this$_sessionAttribu11.deliveryGroup) === null || _this$_sessionAttribu12 === void 0 ? void 0 : _this$_sessionAttribu12.partySize;

        if (partySize && this.orderTypeValue === ORDER_TYPES.CATERING_DELIVERY) {
          return partySize;
        }
      }

      return false;
    }
  }, {
    key: "addExtraCheese",
    get: function get() {
      return this.showAllItems && (this.plates || this.heatingkit || this.bowls || this.cups || this.ice);
    }
  }, {
    key: "occasionInfo",
    get: function get() {
      return this._occasionInfo;
    },
    set: function set(_occasionInfo) {
      var _this17 = this;

      runInAction(function () {
        _this17._occasionInfo = _occasionInfo;
      });
    }
  }, {
    key: "occasionSelected",
    get: function get() {
      return this._occasionSelected;
    },
    set: function set(_occasionSelected) {
      var _this18 = this;

      runInAction(function () {
        _this18._occasionSelected = _occasionSelected;
      });
    }
  }, {
    key: "noOfGuest",
    get: function get() {
      return this._noOfGuest;
    },
    set: function set(val) {
      var _this19 = this;

      runInAction(function () {
        _this19._noOfGuest = val;
      });
    }
  }, {
    key: "quantity",
    get: function get() {
      return this._quantity;
    },
    set: function set(_quantity) {
      var _this20 = this;

      runInAction(function () {
        _this20._quantity = _quantity;
      });
    }
  }, {
    key: "guestCount",
    get: function get() {
      if (this.isQuantityEnabled && this.includeSilverware) return this.quantity;else if (this.isNoOfGuestsEnabled) return this.noOfGuest;else return 1;
    }
  }, {
    key: "isTogoBagFeeEnabled",
    get: function get() {
      var _this$_sessionAttribu13, _this$_sessionAttribu14;

      return (_this$_sessionAttribu13 = this._sessionAttributes) === null || _this$_sessionAttribu13 === void 0 ? void 0 : (_this$_sessionAttribu14 = _this$_sessionAttribu13.carryoutBagDetails) === null || _this$_sessionAttribu14 === void 0 ? void 0 : _this$_sessionAttribu14.isEnabled;
    }
  }, {
    key: "isBagFeeSelected",
    get: function get() {
      return this._isBagFeeSelected;
    },
    set: function set(val) {
      var _this21 = this;

      runInAction(function () {
        _this21._isBagFeeSelected = val;
      });
    }
  }, {
    key: "showSilverwareYesOptionFirst",
    get: function get() {
      var _this$_appAttributes11, _this$_appAttributes12;

      return ((_this$_appAttributes11 = this._appAttributes) === null || _this$_appAttributes11 === void 0 ? void 0 : (_this$_appAttributes12 = _this$_appAttributes11.configs) === null || _this$_appAttributes12 === void 0 ? void 0 : _this$_appAttributes12.showSilverwareYesOptionFirst) || false;
    }
  }, {
    key: "displayComplimentaryItemsBelow",
    get: function get() {
      var _BrandRules, _this$_appAttributes13;

      return (_BrandRules = new BrandRules((_this$_appAttributes13 = this._appAttributes) === null || _this$_appAttributes13 === void 0 ? void 0 : _this$_appAttributes13.currentConceptCode)) === null || _BrandRules === void 0 ? void 0 : _BrandRules.displayComplimentaryItemsOptionsBelow();
    }
  }]);

  return OrderInstructionModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_includeSilverware", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_specialInstructions", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_showSpecialInstructions", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_sessionAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_plates", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_heatingkit", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_bowls", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_cups", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_ice", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_componentRef", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_occasionInfo", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_occasionSelected", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_noOfGuest", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_quantity", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "_isBreadIncluded", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "_condimentsList", [_dec, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "_errorsYPosition", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "_showError", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "_isBagFeeSelected", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errorsYPosition", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errorsYPosition"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showError", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowError", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "includeSilverware", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "includeSilverware"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isBreadIncluded", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isBreadIncluded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "condimentsList", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "condimentsList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedCondiments", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedCondiments"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "specialInstructions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "specialInstructions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showSpecialInstructions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showSpecialInstructions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "plates", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "plates"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "heatingkit", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "heatingkit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "bowls", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "bowls"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cups", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cups"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "ice", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "ice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "componentRef", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "componentRef"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isComplementaryItemsEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isComplementaryItemsEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSilverwareRequired", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSilverwareRequired"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderTypeValue", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderTypeValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isComplementaryItemEnabledForToGoPickup", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isComplementaryItemEnabledForToGoPickup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isToGoOrder", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isToGoOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showAllItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showAllItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showHeatingKit", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showHeatingKit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isFoodItem", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFoodItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSoupItem", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSoupItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isBeverageItem", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isBeverageItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isBreadSelectionEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isBreadSelectionEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isQuantityEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isQuantityEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isQuantityVisible", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isQuantityVisible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isNoOfGuestsEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isNoOfGuestsEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "special_instruction_maxlength", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "special_instruction_maxlength"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displaySpecialInstructions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displaySpecialInstructions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSilverWareShown", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSilverWareShown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cateringOrderPartysize", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cateringOrderPartysize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addExtraCheese", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "addExtraCheese"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "occasionInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "occasionInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "occasionSelected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "occasionSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "noOfGuest", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "noOfGuest"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "quantity", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "quantity"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "guestCount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "guestCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isTogoBagFeeEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isTogoBagFeeEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isBagFeeSelected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isBagFeeSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showSilverwareYesOptionFirst", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showSilverwareYesOptionFirst"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayComplimentaryItemsBelow", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayComplimentaryItemsBelow"), _class.prototype)), _class));
export { OrderInstructionModel as default };